module.exports = __webpack_public_path__ + "static/media/偏偏喜欢你（陈百强）.8198e57f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/static/music/偏偏喜欢你（陈百强）.mp3
// module id = 490
// module chunks = 0